<template>
<BlockConfig title="Tabella misure"
    :valid="valid"
    @handleSave="handleSave"
    @restore="restore">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
            <v-text-field dense outlined
                class="ml-2"
                label="nr. prove di carico*"
                v-model="config_data.min_readings"
                :rules="[rules.mandatory]"
            ></v-text-field>
        </div>
        <div>
            <v-label>etichette tabella<span class="caption"> - (ordine fisso)</span></v-label>
            <div class="d-flex mt-2 flex-wrap">
                <v-text-field dense outlined label="Valore suggerito" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.nom"></v-text-field>
                <v-text-field dense outlined label="Carico di prova" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mass"></v-text-field>
                <v-text-field dense outlined label="Velocità funzionamento" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.speed"></v-text-field>
                <v-text-field dense outlined label="Posizione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.pos"></v-text-field>
                <v-text-field dense outlined label="Numero di letture" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.num"></v-text-field>
                <v-text-field dense outlined label="Lettura numero" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.n"></v-text-field>
                <v-text-field dense outlined label="Indicazione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                <v-text-field dense outlined label="Errore" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.error"></v-text-field>
                <v-text-field dense outlined label="Errore medio" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.max_error"></v-text-field>
                <v-text-field dense outlined label="MPE" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mpe"></v-text-field>
            </div>
        </div>
    </v-form>
    </BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    // props:['data'],
    mixins: [ConfigMixin],
    data() {
        return {
            // valid: false,
            // rules: f_rules,
            o_data: {
                title: this.data.block.label,
                min_readings: null,
                hi_res: "off",
                headers: {
                    nom: 'Valore suggerito',
                    mass: 'Carico di prova',
                    speed: 'Velocità funzionamento (m/s)',
                    pos: 'Posizione',
                    num: 'N. Pesate',
                    n: 'N.',
                    reading: 'Pesata',
                    error: 'Errore',
                    max_error: 'Errore massimo',
                    mpe: 'Errore permesso'
                }
            }
        }
    },
    methods: {
        initCustomData() {
            if(this.data.block.name === "linearity"){
                 this.o_data.min_readings = 4
             } else if (this.data.block.name === "pretest" || this.data.block.name === "eccentricity"){
                 this.o_data.min_readings = 2
             }
        }
    }
}
</script>